module.exports = __webpack_public_path__ + "static/media/solutionFail.d1b904af.jpg";